var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 47",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(46.2461 46.7734) rotate(-180)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_906_9189",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "47",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "46.2461",
              y: "46.7734",
              width: "46",
              height: "46",
              rx: "6",
              transform: "rotate(-180 46.2461 46.7734)",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_906_9189)" } }, [
        _c("path", {
          attrs: {
            d: "M46.2461 0.773438H0.246094V46.7734H46.2461V0.773438Z",
            fill: "white",
          },
        }),
        _c("path", {
          attrs: {
            d: "M46.2461 0.773438H0.246094V23.7736C0.246094 36.476 10.5437 46.7734 23.2463 46.7734C35.9487 46.7734 46.2461 36.476 46.2461 23.7736V0.773438Z",
            fill: "#FFB400",
          },
        }),
        _c("path", {
          attrs: {
            d: "M23.2452 14.6641C18.2148 14.6641 14.1367 18.7421 14.1367 23.7726C14.1367 28.8028 18.2148 32.8808 23.2452 32.8808C28.2754 32.8808 32.3534 28.8028 32.3534 23.7726C32.3534 18.7421 28.2754 14.6641 23.2452 14.6641Z",
            fill: "#3C6EC8",
          },
        }),
        _c("path", {
          attrs: {
            d: "M0.246262 46.7734L46.2461 46.7734L46.2461 0.773602L0.246262 0.773602L0.246262 46.7734Z",
            fill: "#65BBE5",
          },
        }),
        _c("path", {
          attrs: {
            d: "M23.2459 46.7734C35.9484 46.7734 46.2458 36.4759 46.2458 23.7734C46.2458 11.0709 35.9484 0.773438 23.2459 0.773438C10.5435 0.773438 0.246094 11.0709 0.246094 23.7734C0.246094 36.4759 10.5435 46.7734 23.2459 46.7734Z",
            fill: "#3297C9",
          },
        }),
        _c("path", {
          attrs: {
            d: "M23.2472 35.2992C29.6098 35.2992 34.7678 30.1412 34.7678 23.7785C34.7678 17.4158 29.6098 12.2578 23.2472 12.2578C16.8845 12.2578 11.7266 17.4158 11.7266 23.7785C11.7266 30.1412 16.8845 35.2992 23.2472 35.2992Z",
            fill: "#65BBE5",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }